import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5088c1cc"
import script from "./index.vue?vue&type=script&route=%2Fspu%2Flist&lang=js"
export * from "./index.vue?vue&type=script&route=%2Fspu%2Flist&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports